import Seo from "../components/Seo";

export default function Privacy() {
  return (
    <>
      <Seo
        title="Privacy Policy | Zero Harm AI"
        description="Zero Harm AI privacy policy — how we collect, use, and protect your information."
        path="/privacy"
      />

      <div className="max-w-4xl mx-auto px-4 py-10 text-gray-700">
        <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
          Privacy Policy
        </h1>
        <p className="text-sm text-gray-500 mb-8">Last updated: July 8, 2026</p>

        <section className="space-y-5">
          <p>
            Zero Harm AI respects your privacy. This policy explains what information
            we collect, how we use it, and how you can contact us about your data.
          </p>

          <div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              Information We Collect
            </h2>
            <p>
              We may collect information you provide through our contact form,
              including your name, email address, company, inquiry type, and
              message. If you use a live demo, we process the text you submit to
              provide the requested result.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              How We Use Information
            </h2>
            <p>
              We use submitted information to respond to inquiries, provide demos,
              improve our services, protect our systems, and comply with legal
              obligations. We do not sell your personal information.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              Service Providers
            </h2>
            <p>
              We may use trusted service providers for hosting, analytics,
              communications, and security. These providers may process data only
              as needed to support Zero Harm AI services.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              Data Retention
            </h2>
            <p>
              We keep information only as long as needed for the purposes described
              in this policy, unless a longer retention period is required by law.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">Contact</h2>
            <p>
              For privacy questions or requests, contact us at{" "}
              <a
                href="mailto:info@zeroharmai.com"
                className="text-blue-700 underline hover:text-blue-800"
              >
                info@zeroharmai.com
              </a>
              .
            </p>
          </div>
        </section>
      </div>
    </>
  );
}
